module.exports = __webpack_public_path__ + "static/media/condominium-large.05062739.png";